import { render } from "./AMOUN Pharmaceutical.vue?vue&type=template&id=2661784a&scoped=true"
const script = {}

import "./AMOUN Pharmaceutical.vue?vue&type=style&index=0&id=2661784a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2661784a"

export default script